export default "/acfdf2704e412c85fb550b6408622629b62bf7b2/a92d826d80900dda6092d3b109ffaee1.svg";